module.exports = __webpack_public_path__ + "static/media/vegitables_item_list.99e46bec.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_item_list.csv
// module id = 670
// module chunks = 0